import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';

import { Observable, of, ReplaySubject } from 'rxjs';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { map } from 'rxjs/operators';
import { DottedKey } from '../../../../../core/field-definitions/entities/field-definition.entity';
import { ShFieldDefinitionService } from '../../../../../core/field-definitions/services/field-definition.service';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { ShIconModule } from '../../../../../elements/components/icon/icon.module';
import { ShFieldLabelComponent } from '../../../../../form-controls/components/_core/field-label/field-label.component';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSearchRoutingService } from '../../../../services/search-routing.service';
import { ShSimpleReadonlyFieldComponent } from '../simple-readonly-field/simple-readonly-field.component';

@Component({
    standalone: true,
    selector: 'sh-field-definition-readonly-field',
    templateUrl: './field-definition-readonly-field.component.html',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RouterModule, ShIconModule, ShFieldLabelComponent]
})
export class ShFieldDefinitionReadonlyFieldComponent extends ShSimpleReadonlyFieldComponent implements OnDestroy {
    private readonly fieldDefinitionService: ShFieldDefinitionService = inject(ShFieldDefinitionService);

    public icon$: ReplaySubject<string> = new ReplaySubject<string>(1);
    public fieldDefinitionValue$: Observable<string | null>;

    constructor(
        protected fieldHelper: FieldReadHelper,
        protected searchRoutingService: ShSearchRoutingService
    ) {
        super(fieldHelper, searchRoutingService);
    }

    init(profileField: ExtendedBaseProfileField, record: PartialRecord): void {
        const value: string | null = this.fieldHelper.getSimpleFieldValue(profileField.FieldDefinition, record);

        if (value) {
            const fieldDefinition$ = this.fieldDefinitionService.getByDottedKey(value as DottedKey);
            this.fieldDefinitionValue$ = fieldDefinition$.pipe(
                map(fieldDefinition => (fieldDefinition ? fieldDefinition.Label : null))
            );
        } else {
            this.fieldDefinitionValue$ = of(null);
        }
    }

    ngOnDestroy() {
        this.icon$.complete();

        super.ngOnDestroy();
    }
}
